module.exports = __webpack_public_path__ + "img/sort_up.ff798736.svg";